import { CompanyIcon } from '@/icons/CompanyIcon'
import { CouponIcon } from '@/icons/Coupon'

export const getRegion = (eventData) => {
  return eventData?.region || '-'
}

export const getTicketsAvailable = (quantityAvailable = 0) => {
  const available = quantityAvailable ?? 0
  return `${available} ${available === 1 ? 'disponível' : 'disponíveis'}`
}

export const getTicketsRedeemed = (quantityAvailable = 0, quantity = 0) => {
  const available = quantityAvailable ?? 0
  const total = quantity ?? 0
  const redeemed = total - available
  return `${redeemed}/${total} ${redeemed === 1 ? 'resgatado' : 'resgatados'}`
}

export const getEventTypeInfo = (tag) => {
  const eventTypes = {
    EXCLUSIVE_EVENTS: { label: 'Eventos Exclusivos', color: 'brand', icon: <CouponIcon /> },
    FACTORY_VISIT: { label: 'Visita à fábrica', color: 'brand', icon: <CompanyIcon /> }
  }

  return eventTypes[tag] || { label: 'Evento', color: 'default', icon: <CouponIcon /> }
}

export const getEventStartTime = (startTime) => {
  if (!startTime) return null

  // Se já vier no formato HH:MM, retorna diretamente
  if (typeof startTime === 'string' && /^\d{2}:\d{2}$/.test(startTime)) {
    return startTime
  }

  // Se vier como ISO string (ex: '2025-07-12T19:00:00.000Z')
  // Extrai apenas a parte do horário, ignorando o timezone
  if (typeof startTime === 'string' && startTime.includes('T')) {
    const timePart = startTime.split('T')[1]
    const hours = timePart.substring(0, 2)
    const minutes = timePart.substring(3, 5)
    return `${hours}:${minutes}`
  }

  // Fallback para conversão tradicional
  const date = new Date(startTime)
  return date.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'America/Sao_Paulo'
  })
}
